
import { Button } from "@/components/ui/button"
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"
import { Trash } from "lucide-react"
import type { Database } from "@/integrations/supabase/types"

type Category = Database["public"]["Tables"]["client_categories"]["Row"]
type Field = Database["public"]["Tables"]["category_fields"]["Row"]

interface CategoryListProps {
  categories: Category[] | undefined
  fields: Field[] | undefined
  onDeleteCategory: (id: string) => Promise<void>
  onDeleteField: (id: string) => Promise<void>
}

export function CategoryList({
  categories,
  fields,
  onDeleteCategory,
  onDeleteField,
}: CategoryListProps) {
  const getOptionsString = (options: Field["options"]) => {
    if (Array.isArray(options)) {
      return options.join(", ")
    }
    return ""
  }

  return (
    <>
      {categories?.map((category) => (
        <Card key={category.id}>
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle>{category.name}</CardTitle>
              <Button
                variant="destructive"
                size="sm"
                onClick={() => onDeleteCategory(category.id)}
              >
                <Trash className="h-4 w-4" />
              </Button>
            </div>
            {category.description && (
              <p className="text-sm text-muted-foreground">
                {category.description}
              </p>
            )}
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {fields
                ?.filter((field) => field.category_id === category.id)
                .map((field) => (
                  <div
                    key={field.id}
                    className="flex items-center justify-between border-b pb-2"
                  >
                    <div>
                      <p className="font-medium">{field.field_name}</p>
                      <p className="text-sm text-muted-foreground">
                        Type: {field.field_type}
                        {field.required && " (Required)"}
                        {field.options && (
                          <>
                            <br />
                            Options: {getOptionsString(field.options)}
                          </>
                        )}
                      </p>
                    </div>
                    <Button
                      variant="destructive"
                      size="sm"
                      onClick={() => onDeleteField(field.id)}
                    >
                      <Trash className="h-4 w-4" />
                    </Button>
                  </div>
                ))}
            </div>
          </CardContent>
        </Card>
      ))}
    </>
  )
}
